import { ErrorMessage } from "formik";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import React from "react";

type MuiErrorMessageProps = Omit<
  React.ComponentProps<typeof ErrorMessage>,
  "render"
> & { tProps?: Record<string, number | string> };

export const MuiErrorMessage: React.FC<MuiErrorMessageProps> = (props) => {
  const { t } = useTranslation();
  const { tProps, ...errorMessageProps } = props;

  return (
    <ErrorMessage
      {...errorMessageProps}
      render={(e) => (
        <Typography component="span" variant="body2" color="error">
          {t(e, tProps)}
        </Typography>
      )}
    />
  );
};
